import { createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, openBlock as _openBlock } from "vue";

export default function render(_ctx, _cache) {
  return (
    _openBlock(),
    _createElementBlock(
      "svg",
      {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "none",
        viewBox: "0 0 20 20",
      },
      [
        _createElementVNode("path", {
          fill: "currentColor",
          "fill-rule": "evenodd",
          d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10m-4.796-1.462c.806 0 1.461.655 1.461 1.462 0 .596-.362 1.111-.842 1.345.024.14.035.28.035.433 0 2.245-2.608 4.058-5.836 4.058s-5.836-1.813-5.836-4.058c0-.152.012-.304.035-.445a1.463 1.463 0 0 1 .596-2.795c.386 0 .749.164 1.006.41 1.006-.738 2.398-1.194 3.954-1.24l.736-3.486a.3.3 0 0 1 .117-.164.3.3 0 0 1 .2-.035l2.42.515c.164-.351.515-.585.924-.585.573 0 1.041.468 1.041 1.041s-.468 1.041-1.04 1.041a1.04 1.04 0 0 1-1.042-.994l-2.163-.456-.667 3.123c1.52.058 2.9.526 3.895 1.24a1.4 1.4 0 0 1 1.005-.41ZM7.705 10c-.573 0-1.04.468-1.04 1.04 0 .574.467 1.042 1.04 1.042s1.041-.468 1.041-1.041S8.28 10 7.707 10Zm2.304 4.55c.398 0 1.755-.047 2.468-.76a.3.3 0 0 0 .024-.387.276.276 0 0 0-.386 0c-.456.445-1.404.609-2.094.609s-1.649-.164-2.093-.609a.275.275 0 0 0-.386 0 .275.275 0 0 0 0 .386c.701.702 2.07.76 2.468.76Zm1.24-3.51c0 .574.468 1.042 1.041 1.042s1.041-.468 1.041-1.041S12.864 10 12.292 10c-.574 0-1.042.468-1.042 1.04Z",
          "clip-rule": "evenodd",
        }),
      ]
    )
  );
}
